"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PropertyTypeCategory;
(function (PropertyTypeCategory) {
  PropertyTypeCategory["HOUSE"] = "HOUSE";
  PropertyTypeCategory["UNIT"] = "UNIT";
  PropertyTypeCategory["TOWNHOUSE"] = "TOWNHOUSE";
  PropertyTypeCategory["OTHER"] = "OTHER";
})(PropertyTypeCategory || (PropertyTypeCategory = {}));
var _default = exports.default = PropertyTypeCategory;